export default {
  "form.mandatoryField": "入力必須",
  "form.plsEnter": "を入力してください",
  "form.plsFillInAllRequiredFields": "すべての項目を入力してください",
  "form.plsEnterYourName": "名前を入力してください",
  "form.plsEnterPrice": "価格を入力してください",
  "form.plsEnterYourUsername": "ログインユーザー名を入力してください",
  "form.plsEnterYourPassword": "パスワードを入力してください",
  "form.plsEnterYourPasswordAgain": "もう一度パスワードを入力してください",
  "form.plsEnterYourEmail": "メールアドレスを入力してください",
  "form.plsEnterYourMobileNum": "電話番号を入力してください",
  "form.plsSelectTaxRate": "消費税率を選択してください",
  "form.plsEnterSorting": "並べ替え順を入力してください",
  "form.plsEnterUnit": "単位を入力してください",
  "form.PlsEnterUnitPrice": "単価を入力してください",
  "form.plsEnterQuantity": "数量を入力してください",
  "form.plsEnterSalesDepartment": "販売グループを選択してください",
  "form.plsEnterProductCode": "商品コードを入力してください",
  "form.plsEnterNum": "数字を入力してください",
  "form.ticket.plsEnterNum": "発行/有効したい枚数を入力してください（例：「10」＝10枚）",
  "form.plsEnterNumDispOrder_POS": "表示順番（POS）を入力してください",
  "form.plsEnterNumDispOrder_SC": "表示順番（自動券売機）を入力してください",
  "form.displayPOS": "グループ表示（POS）",
  "form.plsSelectGroupofSale_POS": "グループ表示（POS）を選択してください",
  "form.displaySC": "グループ表示（自動券売機）",
  "form.plsSelectGroupofSale_SC": "グループ表示（自動券売機）を選択してください",
  "form.plsSelectAnItem": "アイテムを選択してください",
  "form.plsSelectReset": "全部適用",
  "form.plsSelectAType": "種類を選択してください",
  "form.plsSelectTtemOrOption": "アイテム / オプションを選択してください",
  "form.plsEnterAccReceivable": "売掛金（¥）を入力してください",
  "form.plsEnterFee": "手数料を入力してください",
  "form.plsEnterTitleOfWorks": "作品名を入力してください",
  "form.plsSelectScreen": "スクリーンを選択してください",
  "form.plsEnterAmount": "金額を入力してください",
  "form.plsEnterMsg": "メッセージを入力してください",
  "form.mustFillInNum": "数字の入力が必須です",
  "form.plsSelectScreenStandard": "スクリーン規格を選択してください",
  "form.plsSelectSubtitlesDubbing": "字幕 / 吹替を選択してください",
  "form.plsEnterGoodsCode": "品目コードを入力してください",
  "form.plsEnterComment": "詳細/摘要を入力してください",
  "form.plsSelect": "選択してください",
  "form.mustFillInPositiveNum": "0以上の数字を入力してください",
  "form.plsEnterCorrectPercentage": "％を入力してください",
  "form.hexColorError": "正しい色コードを入力してください",
  "form.plsSelectAllTypes": "すべてのタイプ選んでください",
  "form.emailHasExisting": "すでに使用済みのメールアドレスを利用できません",
  "form.plsSelectDate": "日付を選択してください",
  "form.plsSelectCinema": "劇場を選択してください",
  "form.plsSelectPlatform": "デバイスを選択してください"
};